import React from 'react';
import Modal from 'react-bootstrap/Modal';

const ErrorModal = ({
    show,
    title = "Validation Errors",
    content = {}, // Accepts error object or array
    condition = false,
    onCancel,
    onConfirm,
}) => {

    // Normalize the content to an array (whether it's an object or array)
    const getErrorMessages = (content) => {
        if (Array.isArray(content)) {
            return content;
        } else if (typeof content === "object" && content !== null) {
            return Object.values(content);
        } else if (typeof content === "string") {
            return [content];
        } else {
            return [];
        }
    };

    const errorMessages = getErrorMessages(content);

    return (
        <Modal show={show} onHide={onCancel} centered size="md" backdrop="static" keyboard={false}>
            {/* Modal Header */}
            <Modal.Header className="border-0 d-flex justify-content-center" style={{ backgroundColor: "#f8d7da" }}>
                <div className="d-flex align-items-center gap-2">
                <i class="bi bi-exclamation-triangle-fill"></i>
                <h5 className="modal-title mb-0">{title}</h5>
                </div>
            </Modal.Header>

            {/* Modal Body */}
            <Modal.Body style={{ backgroundColor: "#ffffff" }}>
                {errorMessages.length > 0 ? (
                    <ul className="list-unstyled text-danger text-center mb-0" style={{ fontSize: "16px" }}>
                        {errorMessages.map((error, index) => (
                            <li key={index}>• {error}</li>
                        ))}
                    </ul>
                ) : (
                    <p className="text-center mb-0">No errors found.</p>
                )}
            </Modal.Body>

            {/* Modal Footer */}
            {condition && (
                <Modal.Footer className="d-flex justify-content-center border-0" style={{ backgroundColor: "#ffffff" }}>
                    {onCancel && (
                        <button className="btn btn-secondary px-4" onClick={onCancel}>
                            Close
                        </button>
                    )}
                    {onConfirm && (
                        <button className="btn btn-danger px-4" onClick={onConfirm}>
                            Confirm
                        </button>
                    )}
                </Modal.Footer>
            )}
        </Modal>
    );
};

export default ErrorModal;
